import { AuthorizationInfo, AppSecurityInfo } from './auth-info';

// --------------------------------------------------------------------------------
export class RoleNames {
    static User_admin = 'USER-ADMIN';
    static Internal = 'INTERNAL';
}

// --------------------------------------------------------------------------------
export class RoleLevels {
    static Account = 'ACCOUNT';
    static Subscription = 'SUBSCRIPTION';
    // static Domain = 'DOMAIN';
    // static Instance = 'INSTANCE';
    static All = '*';
}

// --------------------------------------------------------------------------------

export enum RolesWeight {
    // for roles < 100, use CheckMinRoles
    ADMIN = 0,
    PUBLIC = 2,
    ESPADMIN = 3,
    COUSERADMIN = 4,
    USERADMIN = 6,
    EXTERNALDVLP = 7,
    INTERNAL = 8,
    DEVELOPER = 10,
    DEVOPS = 12,
    SYSADMIN = 99,
    // for applicative roles, > 100, use CheckSpecificRoles instead of CheckMinRoles
    POWERUSER = 102,
    POWERUSERSCHEDULER = 103,
    POWERUSERREPORT = 104,
    SECURITYADMIN = 189,
    APPLICATIONADMIN = 199,
    CMSADMIN = 1001, //checkSpecificRole
    INDUSTRIESEDITORADMIN = 1002, //checkSpecificRole
    AMAZONDSP = 2000, //checkSpecificRole
}

export namespace AuthHelper {
    // return an AuthorizationProperties within an OperationResult

    export function GetAuthorizationsFromJWT(unparsedToken: string): { AuthInfo: AuthorizationInfo; AppInfo: AppSecurityInfo } {
        // decoding jwt token
        const tokenParts: Array<string> = unparsedToken.split('.');

        if (tokenParts.length !== 3) {
            return null;
        }

        const decodedToken: string = atob(tokenParts[1]);
        const parsedToken = JSON.parse(decodedToken);

        const authInfo: AuthorizationInfo = new AuthorizationInfo(unparsedToken);

        authInfo.authorizationProperties.accountName = parsedToken.AccountName;
        authInfo.authorizationProperties.accountEmail = parsedToken.AccountEmail;
        authInfo.authorizationProperties.currentInstanceKey = parsedToken.InstanceKey;

        // authInfo.SetRoles(parsedToken.Roles);

        return { AuthInfo: authInfo, AppInfo: parsedToken.AppSecurity };
    }
}
